import React from 'react';
import { Box, Grid, Typography } from '@material-ui/core';

const ModeSummary = ({ data }) => {
    return (
        <>
            {data.map((item) => (
                <Box
                    key={String(item.PaymentModeMasterID)}
                    style={{
                        padding: '10px',
                        background: '#f1f1f1',
                        marginBottom: '7px',
                        borderBottom: '1px solid #fff'
                    }}
                    width="1"
                >
                    <Grid container spacing={3}>
                        <Grid item xs={4}>
                            <Typography
                                sx={{ fontSize: '20px', fontWeight: '500' }}
                            >
                                {item.PaymentModeMaster}
                            </Typography>
                        </Grid>
                        <Grid item xs={4}>
                            {item.Bank}
                        </Grid>
                        <Grid item xs={4}>
                            {item.Balance}
                        </Grid>
                    </Grid>
                </Box>
            ))}
        </>
    );
};

export default ModeSummary;
